<template>
  <div class="card">
    <h5 class="card-header bg-primary text-white">Interview Score</h5>
    <div class="card-body">
      <form>
        <div class="form-row">
          <div class="col-12 col-md-6">
            <div class="form-group row mr-3">
              <label class="col-4 col-form-label">Report Score</label>
              <input
                type="text"
                class="col-8 col-md-7 form-control-plaintext text-center font-weight-bold"
                :class="getScoreClass(summary.scoreCode)"
                placeholder="---"
                :disabled="isLoading"
                :value="summary.scoreDisplayName"
              />
            </div>
          </div>
          <div class="col-12 col-md-6 d-print-none" v-if="isReportDecisionEditor">
            <div class="form-group row" data-bs-toggle="tooltip" data-bs-delay="500" title="Document a decision to hire or decline a candiate">
              <label class="col-4 col-form-label">Status</label>
              <select id="inputState" class="col-6 form-control" :disabled="isLoading" v-model="summary.decisionCode" @change="saveDecision">
                <option v-for="decision in reportDecisions" :key="decision.code" :value="decision.code">{{ decision.displayName }}</option>
              </select>
            </div>
          </div>
          <div class="col-12 col-md-6 d-none d-print-inline" v-if="isReportDecisionEditor">
            <div class="form-group row mr-3">
              <label class="col-4 col-form-label">Status</label>
              <input
                type="text"
                class="col-8 form-control-plaintext text-center font-weight-bold"
                :class="getDecisionClass(summary.decisionCode)"
                placeholder="No Decision"
                :disabled="isLoading"
                :value="summary.decisionDisplayName"
              />
            </div>
          </div>
          <div class="col-12 col-md-6" v-if="!isReportDecisionEditor">
            <div class="form-group row mr-3">
              <label class="col-4 col-form-label">Review Result</label>
              <input
                type="text"
                class="col-8 form-control-plaintext text-center font-weight-bold"
                :class="getDecisionClass(summary.decisionCode)"
                placeholder="No Decision"
                :disabled="isLoading"
                :value="summary.decisionDisplayName"
              />
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  props: {
    isLoading: Boolean,
    organizationId: String,
    reportId: String,
    report: Object,
  },
  computed: {
    ...mapGetters("role", ["isReportDecisionEditor"]),
    ...mapGetters("static", ["reportPeriodicDecisions", "reportPreEmploymentDecisions", "reportInvestigationDecisions"]),
    reportDecisions() {
      if (!this.report || !this.report.registration || !this.report.registration.testCode) return [];
      switch (this.report.registration.testCode) {
        case "periodic":
          return this.reportPeriodicDecisions;
        case "pre-employment":
        case "pre-employment-corrections":
        case "pre-employment-community-supervision":
          return this.reportPreEmploymentDecisions;
        case "investigation":
          return this.reportInvestigationDecisions;
        default:
          return [];
      }
    },
    summary() {
      return this.report ? this.report.summary || {} : {};
    },
  },
  methods: {
    getScoreClass(value) {
      if (value === "above-conditions") return ["bg-success", "text-white"];
      if (value === "requires-clarification") return ["bg-warning", "text-white"];
      if (value === "below-conditions") return ["bg-danger", "text-white"];
      if (value === "inconclusive") return ["bg-warning", "text-white"];
      return ["bg-secondary", "text-white"];
    },
    getDecisionClass(value) {
      if (value === "hire" || value === "no_follow_up_required") return ["bg-success", "text-white"];
      if (value === "decline" || value === "follow_up_required" || value === "follow_up_required_admissions" || value === "follow_up_required_observations")
        return ["bg-danger", "text-white"];
      return ["bg-secondary", "text-white"];
    },
    saveDecision(e) {
      this.$emit("loading", "Saving...");
      this.$axios
        .put(`/v1/organizations/${this.organizationId}/reports/${this.reportId}/decision`, { decisionCode: e.target.value })
        .then(() => this.$emit("success", "Decision saved successfully!"))
        .catch(err => this.$emit("error", err))
        .finally(() => {
          this.$emit("loading", null);
        });
    },
  },
};
</script>
